// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2k6Fv","active":"NavigationItem_active__3v8Et"};